import $ from 'jquery';
import 'slick-carousel';

let sliderImageLogin = {
    init() {
        $('.block-slider-image-login .slider').addClass('active');
        $('.block-slider-image-login .slider').slick({
            dots: false,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows : false,
            infinite: true,
            speed: 500,
            fade: true,
        })
    }
}

export default sliderImageLogin;
